/* eslint-disable jsx-a11y/anchor-is-valid */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-05-16 15:26:55
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { useState } from 'react';
import { Collapsible, TextContainer, Icon, Badge } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { StarFilledMinor, MinusMinor } from '@shopify/polaris-icons';
import collapseSquareUp from 'src/assets/images/common/collapse-square-up.png';
import MobileAcceptMajor from 'src/assets/images/common/mobile-accept_major.png';
import FlatRedIcon from 'src/assets/images/subscription-v4/star.svg';

type Props = {
  feature: string,
  data: Array
};

type ComposedProps = Props & WithI18nProps;

const RenderCollapse = (props: ComposedProps) => {
  const { feature, data, i18n } = props;
  const [open, setOpen] = useState(true);
  return (
    <div className="feature-collapse">
      <div
        className="action-collapse"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        aria-controls="basic-collapsible">
        {i18n.translate(`AdminHTML.SubscriptionV4.PackageComparison.${feature}`)}
        <img
          className={`${open ? 'collapse-up' : 'collapse-down'}`}
          src={collapseSquareUp}
          alt="collapse-square-up-icon"
          width={32}
          height={32}
        />
      </div>
      <Collapsible
        open={open}
        id="basic-collapsible"
        transition={{ duration: '500ms', timingFunction: 'ease-in-out' }}
        expandOnPrint>
        <TextContainer>
          {data.map((element, indexRow) => (
            <div key={`row-0${indexRow}`} className="row">
              <div className="column">
                <p
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4
                  }}>
                  <span>{i18n.translate(element.content)}</span>
                  {element.isAddon && (
                    <span>
                      <img src={FlatRedIcon} width={16} height={16} alt="icon" />
                    </span>
                  )}
                </p>
                {element.subtext?.length > 0 &&
                  element.subtext.map((text, i) => (
                    <p key={feature + '-subtext-' + i}>{i18n.translate(text)}</p>
                  ))}
              </div>
              {element.values.map((value, indexColumn) => {
                // case addon
                if (value === 'addon') {
                  return (
                    <div key={`free-${indexColumn}`} className="column addon-badge">
                      <Badge status="warning">
                        <Icon color="warning" source={StarFilledMinor} />
                        <p>{i18n.translate('AdminHTML.SubscriptionV4.PackageComparison.addon')}</p>
                      </Badge>
                    </div>
                  );
                }
                // In case feature free value = 0
                if (value === 0) {
                  return (
                    <div key={`free-${indexColumn}`} className="column">
                      <img src={MobileAcceptMajor} alt="mobile-accept-major" width={14} />
                    </div>
                  );
                }
                // In case feature not available
                if (value === -1) {
                  return (
                    <div key={`free-${indexColumn}`} className="column minus-icon-value">
                      <Icon color="subdued" source={MinusMinor} />
                    </div>
                  );
                }
                if (_.isNumber(value) && value > 0) {
                  return (
                    <div key={`value-${indexColumn}`} className="column badge-price">
                      {value}
                    </div>
                  );
                }

                // In case show text translation
                if (value?.includes('AdminHTML'))
                  return (
                    <div key={`paid-${indexColumn}`} className="column badge-price">
                      {i18n.translate(value)}
                    </div>
                  );

                // default
                return (
                  <div key={`value-${indexColumn}`} className="column">
                    {value}
                  </div>
                );
              })}
            </div>
          ))}
        </TextContainer>
      </Collapsible>
    </div>
  );
};
export default withI18n()(RenderCollapse);
